<template>
	<v-container fluid class="pa-4">
		<v-card flat>
			<v-card-title class="d-flex align-center flex-wrap">
				<v-btn icon @click="$router.push('/portal/projects')" v-if="showBack" class="mr-2">
					<v-icon>mdi-arrow-left</v-icon>
				</v-btn>
				<span>{{ projectName || 'Segnalazioni' }}</span>
				<v-spacer></v-spacer>
				<v-btn color="primary" depressed @click="showReport = true">
					<v-icon left>mdi-plus</v-icon>Segnala
				</v-btn>
			</v-card-title>
			<v-divider></v-divider>

			<!-- Filtri per stato -->
			<v-card-text class="pb-0" v-if="items.length">
				<v-chip-group v-model="filterBucket" column>
					<v-chip filter outlined value="">Tutte ({{ items.length }})</v-chip>
					<v-chip
						v-for="b in buckets"
						:key="b.key"
						filter
						outlined
						:value="b.key"
						:color="b.color"
					>
						{{ b.label }} ({{ countByBucket(b.key) }})
					</v-chip>
				</v-chip-group>
			</v-card-text>

			<v-card-text v-if="loading" class="text-center pa-8">
				<v-progress-circular indeterminate color="primary"></v-progress-circular>
			</v-card-text>

			<v-list v-else-if="filteredItems.length" two-line>
				<template v-for="(item, i) in filteredItems">
					<v-list-item :key="item.id" @click="openItem(item)">
						<v-list-item-content>
							<v-list-item-title class="font-weight-medium">
								{{ item.title }}
								<v-chip x-small label class="ml-2" v-if="item.created_by_portal" color="blue lighten-4">
									<v-icon x-small left>mdi-account</v-icon> tua
								</v-chip>
							</v-list-item-title>
							<v-list-item-subtitle>{{ item.excerpt }}</v-list-item-subtitle>
							<div class="mt-1">
								<v-chip x-small dark :color="item.status_color">{{ item.status_label }}</v-chip>
								<span class="text-caption grey--text ml-2">{{ formatDate(item.created_at) }}</span>
								<span class="text-caption grey--text ml-2" v-if="item.comments_count">
									<v-icon x-small>mdi-comment-outline</v-icon> {{ item.comments_count }}
								</span>
								<span class="text-caption grey--text ml-2" v-if="item.attachments_count">
									<v-icon x-small>mdi-paperclip</v-icon> {{ item.attachments_count }}
								</span>
							</div>
						</v-list-item-content>
						<v-list-item-action>
							<v-icon small>mdi-chevron-right</v-icon>
						</v-list-item-action>
					</v-list-item>
					<v-divider :key="'d-' + i" v-if="i < filteredItems.length - 1"></v-divider>
				</template>
			</v-list>

			<v-card-text v-else class="text-center pa-12 grey--text">
				<v-icon size="64" color="grey lighten-2">mdi-clipboard-check-outline</v-icon>
				<div class="text-h6 mt-4">Nessuna segnalazione</div>
				<v-btn color="primary" depressed class="mt-4" @click="showReport = true">
					<v-icon left>mdi-plus</v-icon>Crea la prima segnalazione
				</v-btn>
			</v-card-text>
		</v-card>

		<portal-report-dialog
			v-model="showReport"
			:project-id="projectId"
			@created="onReported"
		></portal-report-dialog>
	</v-container>
</template>

<script>
import PortalReportDialog from '@/components/modules/portal/PortalReportDialog'

export default {
	name: 'PortalProjectItems',
	components: { PortalReportDialog },
	data() {
		return {
			projectName: '',
			buckets: [],
			items: [],
			loading: false,
			filterBucket: '',
			showBack: false,
			showReport: false
		}
	},
	computed: {
		projectId() {
			return this.$route.params.id
		},
		filteredItems() {
			if (!this.filterBucket) return this.items
			return this.items.filter(i => i.bucket === this.filterBucket)
		}
	},
	created() {
		this.loadItems()
		this.checkBack()
	},
	watch: {
		'$route.params.id'() {
			this.loadItems()
		}
	},
	methods: {
		async loadItems() {
			this.loading = true
			try {
				const resp = await this.axios.get('portal/projects/' + this.projectId + '/items')
				if (resp.data.success) {
					this.projectName = resp.data.data.project.name
					this.buckets = resp.data.data.buckets || []
					this.items = resp.data.data.items || []
				}
			} catch (e) {
				if (e.response && e.response.status === 404) {
					// Dashboard (non /portal/projects) per evitare loop col redirect a progetto singolo
					this.$store.commit('setSnackbar', { value: true, text: 'Progetto non disponibile.', color: 'warning', timeout: 5000 })
					this.$router.replace('/portal')
				} else {
					this.$store.commit('setSnackbarError')
				}
			} finally {
				this.loading = false
			}
		},
		async checkBack() {
			// Mostra "indietro" solo se il cliente ha più di un progetto
			try {
				const resp = await this.axios.get('portal/projects')
				if (resp.data.success) this.showBack = (resp.data.data || []).length > 1
			} catch (e) {
				// silenzioso
			}
		},
		countByBucket(key) {
			return this.items.filter(i => i.bucket === key).length
		},
		openItem(item) {
			this.$router.push('/portal/items/' + item.id)
		},
		onReported(item) {
			// Ricarica la lista e apre la segnalazione appena creata
			this.loadItems()
			if (item && item.id) this.$router.push('/portal/items/' + item.id)
		},
		formatDate(date) {
			if (!date) return ''
			return new Date(date).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' })
		}
	}
}
</script>
